import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { postLoginDestination } from '@/storage/post-login-redirect'

export function PostLoginNavigate() {
  const [to] = useState(postLoginDestination)
  return <Navigate to={to} replace />
}
